import { useRef, useEffect } from 'react';
import { FolderIcon, FolderMinusIcon } from '@heroicons/react/24/outline';
import { ChatCategory } from '../types/chat';

interface CategoryMenuProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (category: ChatCategory) => void;
  currentCategory?: ChatCategory;
}

export default function CategoryMenu({ isOpen, onClose, onSelect, currentCategory }: CategoryMenuProps) {
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  if (!isOpen) return null;

  const categories: ChatCategory[] = ['Work', 'Personal', 'Important'];

  return (
    <div 
      ref={menuRef}
      className="fixed z-50 w-48 rounded-md shadow-lg bg-white dark:bg-gray-800 ring-1 ring-black ring-opacity-5"
      style={{
        position: 'absolute',
        right: '3rem',
        top: '0',
      }}
    >
      <div className="py-1">
        <button
          onClick={() => {
            onSelect('All');
            onClose();
          }}
          className={`w-full text-left px-4 py-2 text-sm text-red-600 dark:text-red-400 hover:bg-gray-100 dark:hover:bg-gray-700 border-b border-gray-200 dark:border-gray-700`}
        >
          <div className="flex items-center gap-2">
            <FolderMinusIcon className="w-4 h-4" />
            Remove from folder
          </div>
        </button>

        {categories.map((category) => (
          <button
            key={category}
            onClick={() => {
              onSelect(category);
              onClose();
            }}
            className={`w-full text-left px-4 py-2 text-sm ${
              currentCategory === category
                ? 'bg-blue-50 dark:bg-blue-900 text-blue-700 dark:text-blue-200'
                : 'text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700'
            }`}
          >
            <div className="flex items-center gap-2">
              <FolderIcon className="w-4 h-4" />
              {category}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
} 